exports = module.exports = require("../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ball-scale-ripple-multiple>div,.ball-scale-ripple>div,.ball-triangle-path>div{background-color:initial;border-color:currentColor}.ball-clip-rotate>div{background-color:initial;border-top-color:currentColor;border-right-color:currentColor;border-left-color:currentColor}.ball-clip-rotate-pulse>div:first-child{background-color:currentColor}.ball-clip-rotate-pulse>div:last-child{background-color:initial;border-top-color:currentColor;border-bottom-color:currentColor}.ball-clip-rotate-multiple>div:first-child{background-color:initial;border-right-color:currentColor;border-left-color:currentColor}.ball-clip-rotate-multiple>div:last-child{border-top-color:currentColor}.ball-clip-rotate-multiple>div:last-child,.pacman>div:first-child,.pacman>div:nth-child(2),.triangle-skew-spin>div{background-color:initial;border-bottom-color:currentColor}.pacman>div:first-child,.pacman>div:nth-child(2){border-top-color:currentColor;border-left-color:currentColor}.pacman>div:nth-child(3),.pacman>div:nth-child(4),.pacman>div:nth-child(5){background-color:currentColor}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/react-spinkit/css/loaders-css.css
// module id = 841
// module chunks = 0